import React, { Component } from 'react';
// import PropTypes from "prop-types";

export class LandingPage extends Component {
  render() {
    return <div>LandingPage</div>;
  }
}

// https://reactjs.org/docs/typechecking-with-proptypes.html#proptypes
LandingPage.propTypes = {};

export default LandingPage;



// WEBPACK FOOTER //
// ./src/pages/LandingPage.js